export default "__VITE_ASSET__ByHRh2rV__"